import React, { useState } from 'react';
import { CircleHelp } from 'lucide-react';
import { useHints, useHintText } from '../../context/HintsContext';
import { hintAriaLabel } from '../../utils/hintCopy';
import HintPopup from './HintPopup';
import './HelpIcon.css';

/**
 * Quiet ? control beside a confusing label. Hidden when Hints is off.
 */
export default function HelpIcon({ hintKey, ariaLabel }) {
  const { ready, hintsOn } = useHints();
  const copy = useHintText(hintKey);
  const [open, setOpen] = useState(false);

  if (!ready || !hintsOn || !copy) return null;

  const label = ariaLabel || hintAriaLabel(hintKey);

  return (
    <>
      <button
        type="button"
        className="help-icon"
        aria-label={label}
        title={label}
        onClick={() => setOpen(true)}
      >
        <CircleHelp size={16} strokeWidth={2} aria-hidden />
      </button>
      <HintPopup
        isOpen={open}
        onClose={() => setOpen(false)}
        title={copy.title}
        content={copy.content}
        actionLabel={copy.actionLabel}
      />
    </>
  );
}
